/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Land_Title_Showcase_HomeInputs */

const en_shop_land_title_showcase_home = /** @type {(inputs: Shop_Land_Title_Showcase_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · Home`)
};

const ar_shop_land_title_showcase_home = /** @type {(inputs: Shop_Land_Title_Showcase_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · الرئيسية`)
};

const de_shop_land_title_showcase_home = /** @type {(inputs: Shop_Land_Title_Showcase_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · Startseite`)
};

const es_shop_land_title_showcase_home = /** @type {(inputs: Shop_Land_Title_Showcase_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · Inicio`)
};

const fr_shop_land_title_showcase_home = /** @type {(inputs: Shop_Land_Title_Showcase_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · Accueil`)
};

const it_shop_land_title_showcase_home = /** @type {(inputs: Shop_Land_Title_Showcase_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · Home`)
};

const ja_shop_land_title_showcase_home = /** @type {(inputs: Shop_Land_Title_Showcase_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · ホーム`)
};

const ko_shop_land_title_showcase_home = /** @type {(inputs: Shop_Land_Title_Showcase_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · 홈`)
};

const pt_br_shop_land_title_showcase_home = /** @type {(inputs: Shop_Land_Title_Showcase_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · Início`)
};

const ru_shop_land_title_showcase_home = /** @type {(inputs: Shop_Land_Title_Showcase_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · Главная`)
};

const th_shop_land_title_showcase_home = /** @type {(inputs: Shop_Land_Title_Showcase_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · หน้าหลัก`)
};

const tr_shop_land_title_showcase_home = /** @type {(inputs: Shop_Land_Title_Showcase_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · Ana Sayfa`)
};

const zh_cn_shop_land_title_showcase_home = /** @type {(inputs: Shop_Land_Title_Showcase_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · 首页`)
};

const zh_tw_shop_land_title_showcase_home = /** @type {(inputs: Shop_Land_Title_Showcase_HomeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` · 首頁`)
};

/**
* | output |
* | --- |
* | "· Home" |
*
* @param {Shop_Land_Title_Showcase_HomeInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const shop_land_title_showcase_home = /** @type {((inputs?: Shop_Land_Title_Showcase_HomeInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Land_Title_Showcase_HomeInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shop_land_title_showcase_home(inputs)
	if (locale === "ar") return ar_shop_land_title_showcase_home(inputs)
	if (locale === "de") return de_shop_land_title_showcase_home(inputs)
	if (locale === "es") return es_shop_land_title_showcase_home(inputs)
	if (locale === "fr") return fr_shop_land_title_showcase_home(inputs)
	if (locale === "it") return it_shop_land_title_showcase_home(inputs)
	if (locale === "ja") return ja_shop_land_title_showcase_home(inputs)
	if (locale === "ko") return ko_shop_land_title_showcase_home(inputs)
	if (locale === "pt_br") return pt_br_shop_land_title_showcase_home(inputs)
	if (locale === "ru") return ru_shop_land_title_showcase_home(inputs)
	if (locale === "th") return th_shop_land_title_showcase_home(inputs)
	if (locale === "tr") return tr_shop_land_title_showcase_home(inputs)
	if (locale === "zh_cn") return zh_cn_shop_land_title_showcase_home(inputs)
	return zh_tw_shop_land_title_showcase_home(inputs)
});